import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2fc721d4&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=2fc721d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc721d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc721d4')) {
      api.createRecord('2fc721d4', component.options)
    } else {
      api.reload('2fc721d4', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2fc721d4&scoped=true", function () {
      api.rerender('2fc721d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/components/dowload-data/main.vue"
export default component.exports